import React from "react";
import PropTypes from "prop-types";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { getGoogleMapsApiKey } from "utils/appKeys";

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow:
    "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
};

const libraries = ["places", "geometry", "drawing"];

const GOOGLE_MAP_API_KEY = getGoogleMapsApiKey();

console.log("KEY:", GOOGLE_MAP_API_KEY);

function MyGoogleMap({ lat, lng }) {
  const center = React.useMemo(() => ({ lat, lng }), [lat, lng]);
  const [map, setMap] = React.useState(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    libraries,
  });

  const onLoad = React.useCallback((map) => {
    // fitBounds rundt ett punkt zoomer helt inn (nivå 22). Der har Google
    // ingen satellittbilder, fliser svarer 503 og kartet viser «map error».
    map.setZoom(18);
    setMap(map);
  }, [center]);

  const onUnmount = React.useCallback(() => {
    setMap(null);
  }, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={10}
      onLoad={onLoad}
      mapTypeId="satellite"
      onUnmount={onUnmount}
    >
      <Marker position={center} />
    </GoogleMap>
  ) : (
    <></>
  );
}

MyGoogleMap.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
};

export default MyGoogleMap;
